import { JOB_FETCHING, JOB_FAILED, JOB_SUCCESS } from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case JOB_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case JOB_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case JOB_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
